<template>
  <div class="shadow-md p-3">

    <div class="modal" id="imageDialog">
        <div class="modal-dialog">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <img :src="selectedImage" class="d-block w-full max-h-[600px] object-contain" alt="Larger Image" />
            </div>
        </div>
      </div>
    </div>
    
    <div class="w-full flex flex-wrap" id="top">
      <div :class="itemEditable.IDART_IO ? 'w-full md:w-1/2' : 'w-full'" class="order-2 order-md-1">
        <div>
          <div v-if="buscadorMarca != 0" class="flex flex-wrap">
            <input @change="buscadorFiltros(1)" type="text" v-model="buscador" placeholder="Buscador" class="border w-44">
            <div class="flex p-2 items-center gap-1">
              <label for="precio">Ordenar por: </label>
              <select name="precio" id="" class="border w-46" v-model="buscadorPrecio">
                <option :value="null">Sin orden</option>
                <option value="1">Precio, Mayor a Menor</option>
                <option value="0">Precio, Menor a Mayor</option>
                <option value="3">Codigo, Mayor a Menor</option>
                <option value="2">Codigo, Menor a Mayor</option>
              </select>
            </div>
            <div class="flex p-2 items-center gap-1">
              <label for="activos">Estado</label>
              <select name="activos" id="" class="border w-46" v-model="buscadorEstado">
                <option :value="null">Todos los estados</option>
                <option value="1">Activos</option>
                <option value="0">No activos</option>
              </select>
            </div>
          </div>
          <div class="flex p-2 items-center gap-1">
            <label for="marca">Marca</label>
            <select name="marca" id="" class="border w-96" v-model="buscadorMarca" @change="cambioBCats(buscadorMarca == 0 ? 0 : 1)">
              <option :value="null">Todas las marcas</option>
              <option v-for="(marca, key) in categoriasOrdenadas" :key="key" :value="marca.idmarca">{{ marca.marca }}</option>
              <option value="0">No asignados</option>
            </select>
            <RouterLink v-if="buscadorMarca != 0" to="/admin/productos/categorias" class="btn border">Ordenar Categorias</RouterLink>
          </div>
          <div class="flex p-2 items-center gap-1" v-if="buscadorMarca != null && buscadorMarca != 0">
            <label for="categoria">Categoria</label>
            <select name="categoria" id="" class="border w-96" v-model="buscadorCat" @change="cambioBCats()">
              <option :value="null">Todas las Categorias</option>
              <option v-for="(cat, key) in categoriasOrdenadas.find(x => x.idmarca == buscadorMarca)?.categorias ?? []" :key="key" :value="cat.idcat">{{ cat.categoria }}</option>
              <option value="99">Sin categoria</option>
            </select>
          </div>
          <div class="flex p-2 items-center gap-1" v-if="buscadorMarca && buscadorCat && buscadorCat != 99">
            <label for="categoria">Subcategoria</label>
            <select name="categoria" id="" class="border w-96" v-model="buscadorSubCat">
              <option :value="null">Todas las SubCategorias</option>
              <option v-for="(sub, key) in categoriasOrdenadas.find(x => x.idmarca == buscadorMarca)?.categorias?.find(x => x.idcat == buscadorCat)?.subCategorias ?? []" :key="key" :value="sub.idsubcat">{{ sub.subcategoria }}</option>
            </select>
          </div>
          <div v-if="buscadorMarca == 0">
            <div class="flex gap-3 items-center m-1">
              <input class="form-control w-44" ype="text" id="buscadorNoAsignados">
              <button class="btn btn-sm btn-outline-danger" onclick="const searchText = document.getElementById('buscadorNoAsignados').value; if (searchText) { window.find(searchText); } else { alert('Please enter a search term.'); }">BUSCAR</button>
            </div>
          </div>
          <div class="flex gap-2" v-if="buscadorMarca != 0">
            <button :disabled="cargando" @click="buscadorFiltros(1)" class="btn btn-success btn-sm">Buscar</button>
            <button :disabled="cargando" @click="borrarFiltros()" class="btn btn-danger bg-truered btn-sm">Borrar filtros</button>
            <button :disabled="cargando" @click="exportAllToExcel()" class="btn btn-warning btn-sm">Exportar a excel</button>
            <div class="flex items-center gap-2">
              <label for="quotation">Quotation</label>
              <input :disabled="cargando" type="checkbox" id="quotation" v-model="mostrarCarrito">
              <p v-if="mostrarCarrito" class="cursor-pointer" @click="openQuotModal" >items: {{ cartItems.length }}</p>
              <button :disabled="cargando" v-if="mostrarCarrito && cartItems.length" class="btn btn-warning" @click="exportQuotation()">Exportar quotation</button>
              <button :disabled="cargando" v-if="mostrarCarrito && cartItems.length" class="btn btn-danger bg-truered" @click="exportQuotationPdf()">Exportar quotation PDF</button>
              <button :disabled="cargando" v-if="mostrarCarrito && cartItems.length" class="btn btn-danger" @click="cartItems = []">Reset</button>
            </div>
          </div>
        </div>
        <div v-if="buscadorMarca != 0" class="flex items-center justify-between mt-4" >
          <button
            @click="prevPage"
            :disabled="ultimoIndex == 1 || cargando"
            class="btn btn-primary cursor-pointer hover:bg-blue-600 focus:outline-none"
          >
            Anterior
          </button>
          <p>Pag. {{ ultimoIndex }} / {{ cantPaginas }}</p>
          <button
            @click="nextPage"
            :disabled="cargando || items.length < 25"
            class="btn btn-primary cursor-pointer hover:bg-blue-600 focus:outline-none"
          >
            Siguiente
          </button>
        </div>
        <div>
          <table class="table table-striped table-sm text-xs">
            <thead>
              <tr>
                <th scope="col">Opciones</th>
                <th scope="col">Foto</th>
                <th scope="col">Codigo</th>
                <th scope="col">Nombre</th>
                <th v-if="!itemEditable.IDART_IO" scope="col">Categoria</th>
                <th v-if="!itemEditable.IDART_IO" scope="col">Subcategoria</th>
                <th v-if="!itemEditable.IDART_IO" scope="col">Marca</th>
                <th v-if="!itemEditable.IDART_IO" scope="col">Temporada</th>
                <th v-if="!itemEditable.IDART_IO" scope="col">Precio</th>
                <th v-if="!itemEditable.IDART_IO" scope="col">Oferta</th>
                <th v-if="!itemEditable.IDART_IO" scope="col">Futuro</th>
                <th v-if="!itemEditable.IDART_IO" scope="col">Activo</th>
                <th v-if="!itemEditable.IDART_IO && mostrarCarrito" scope="col">Quotation</th>
              </tr>
            </thead>
            <tbody v-if="buscadorMarca != 0">
              <tr v-for="(item, key) in items" :key="key">
                <td>
                  <button @click="editarItem(key);" class="w-7 mr-1"><img src="../assets/icons/pencil.png" alt="Editar" title="Editar"></button>
                  <!-- <button class="w-7"><img src="../assets/icons/bin.png" alt="Eliminar" title="Eliminar"></button> -->
                </td>
                <td class="clickable" @click="openImageDialog(item.imagenPrincipal.split('|')[0])">
                    <div v-if="!item.imagenPrincipal || !item.imagenPrincipal.split('|')[0]">
                        <img class="d-block w-14 max-h-14 object-contain" src="../assets/no-photo.jpg" alt="Imagen del articulo" />
                    </div>
                    <div v-else>
                        <img 
                            :src="item.imagenPrincipal.split('|')[0]" 
                            :alt="'Imagen del articulo'" 
                            class="d-block w-14 max-h-14 object-contain" 
                        />
                    </div>
                </td>
                <td>{{ item.CODIGO_ART }}</td>
                <td class="text-left">{{ item.DESCRIP_ART }}</td>
                <td v-if="!itemEditable.IDART_IO">{{ item.categoria ? item.categoria : ''  }}</td>
                <td v-if="!itemEditable.IDART_IO">{{ item.subcategoria ? item.subcategoria : ''  }}</td>
                <td v-if="!itemEditable.IDART_IO">{{ item.marca ? item.marca : ''  }}</td>
                <td v-if="!itemEditable.IDART_IO">{{ item.temporada }}</td>
                <td v-if="!itemEditable.IDART_IO" class="text-right">{{ item.PRECIO_LPI.toFixed(2) }}</td>
                <td v-if="!itemEditable.IDART_IO"><input type="checkbox" onclick="return false;"  class="form-checkbox mt-1" :checked="item.OFERTA_IO == 1"></td>
                <td v-if="!itemEditable.IDART_IO"><input type="checkbox" onclick="return false;"  class="form-checkbox mt-1" :checked="item.DESTACADO_IO == 1"></td>
                <td v-if="!itemEditable.IDART_IO"><input type="checkbox" onclick="return false;"  class="form-checkbox mt-1" :checked="item.ACTIVO_IO == 1"></td>
                <td v-if="!itemEditable.IDART_IO && mostrarCarrito"><button :disabled="isIncluded(item)" @click="addQuotation(item)" class="btn btn-success btn-sm">{{ !isIncluded(item) ? 'Añadir' : 'Incluido'}}</button></td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(item, key) in arts" :key="key">
                <td>
                  <button @click="editarArts(key)" class="w-7 mr-1"><img src="../assets/icons/pencil.png" alt="Editar" title="Editar"></button>
                  <!-- <button class="w-7"><img src="../assets/icons/bin.png" alt="Eliminar" title="Eliminar"></button> -->
                </td>
                <td class="clickable" @click="openImageDialog(item.imagenPrincipal.split('|')[0])">
                    <div v-if="!item.imagenPrincipal || !item.imagenPrincipal.split('|')[0]">
                        <img class="d-block w-14 max-h-14 object-contain" src="../assets/no-photo.jpg" alt="Imagen del articulo" />
                    </div>
                    <div v-else>
                        <img 
                            :src="item.imagenPrincipal.split('|')[0]" 
                            :alt="'Imagen del articulo'" 
                            class="d-block w-14 max-h-14 object-contain" 
                        />
                    </div>
                </td>
                <td>{{ item.CODIGO_ART }}</td>
                <td class="text-left">{{ item.DESCRIP_ART }}</td>
                <td v-if="!itemEditable.IDART_IO">{{ item.categoria ? item.categoria : ''  }}</td>
                <td v-if="!itemEditable.IDART_IO">{{ item.subcategoria ? item.subcategoria : ''  }}</td>
                <td v-if="!itemEditable.IDART_IO">{{ item.marca ? item.marca : ''  }}</td>
                <td v-if="!itemEditable.IDART_IO">{{ item.temporada ? item.temporada : '' }}</td>
                <td v-if="!itemEditable.IDART_IO">-</td>
                <td v-if="!itemEditable.IDART_IO"><input type="checkbox" onclick="return false;"  class="form-checkbox mt-1" :checked="item.OFERTA_IO == 1"></td>
                <td v-if="!itemEditable.IDART_IO"><input type="checkbox" onclick="return false;"  class="form-checkbox mt-1" :checked="item.DESTACADO_IO == 1"></td>
                <td v-if="!itemEditable.IDART_IO"><input type="checkbox" onclick="return false;"  class="form-checkbox mt-1" :checked="item.ACTIVO_IO == 1"></td>
                <td v-if="!itemEditable.IDART_IO && mostrarCarrito"><button :disabled="isIncluded(item)" @click="addQuotation(item)" class="btn btn-success btn-sm">{{ !isIncluded(item) ? 'Añadir' : 'Incluido'}}</button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="itemEditable.IDART_IO" class="w-full md:w-1/2 border-1-black border order-1 order-md-2">
        <div class="container">
          <div class="row border-1-black border-b p-1">
            <button @click="itemEditable = {}" class="btn btn-danger bg-truered w-10"><img src="../assets/icons/error.png" alt="cerrar"></button>
          </div>
          <div class="row">
            <p class="flex justify-between p-2">Codigo: {{ itemEditable.CODIGO_ART }}</p>
            <p class="flex justify-between p-2">Descripcion: {{ itemEditable.DESCRIP_ART }}</p>
            <div class="flex justify-between p-2 items-center gap-1">
              <label for="Orden">Orden</label>
              <input class="form-control w-96" id="indicacion" type="number" min="0" v-model="itemEditable.ORDEN_IO">
            </div>
            <div class="flex justify-between p-2 items-center gap-1">
              <label for="marca">Marca</label>
              <select name="marca" id="" class="form-select w-96" v-model="itemEditable.IDMARCA_IO" @change="cambioCats(1)">
                <option :value="null">Sin Marca</option>
                <option v-for="(marca, key) in categoriasOrdenadas" :key="key" :value="marca.idmarca">{{ marca.marca }}</option>
              </select>
            </div>
            <div class="flex justify-between p-2 items-center gap-1" v-if="itemEditable.IDMARCA_IO != null">
              <label for="categoria">Categoria</label>
              <select name="categoria" id="" class="form-select w-96" v-model="itemEditable.IDCATEGORIA_IO" @change="cambioCats()">
                <option :value="null">Sin Categoria</option>
                <option v-for="(cat, key) in categoriasOrdenadas.find(x => x.idmarca == itemEditable.IDMARCA_IO)?.categorias ?? []" :key="key" :value="cat.idcat">{{ cat.categoria }}</option>
              </select>
            </div>
            <div class="flex justify-between p-2 items-center gap-1" v-if="itemEditable.IDMARCA_IO && itemEditable.IDCATEGORIA_IO">
              <label for="categoria">Subcategoria</label>
              <select name="categoria" id="" class="form-select w-96" v-model="itemEditable.IDSUBCATEGORIA_IO">
                <option :value="null">Sin SubCategoria</option>
                <option v-for="(sub, key) in categoriasOrdenadas.find(x => x.idmarca == itemEditable.IDMARCA_IO)?.categorias?.find(x => x.idcat == itemEditable.IDCATEGORIA_IO)?.subCategorias ?? []" :key="key" :value="sub.idsubcat">{{ sub.subcategoria }}</option>
              </select>
            </div>
            <div class="flex justify-between p-2 items-center gap-1">
              <label for="indicacion">Indicación de compra</label>
              <input class="form-control w-96" id="indicacion" type="text" v-model="itemEditable.INDICACION_IO">
            </div>
            <div class="flex justify-between p-2 items-center gap-1">
              <label for="descuento">Descuento</label>
              <div class="flex items-center">
                <p>%</p>
                <input class="form-control w-96" id="descuento" type="number" max="100" min="0" step=".01" v-model="itemEditable.DESCUENTO_IO">
              </div>
            </div>
            <div class="flex justify-between p-2 items-center gap-1">
              <div class="flex items-center gap-1">
                <label for="oferta">Oferta</label>
                <input id="oferta" type="checkbox"  v-model="itemEditable.OFERTA_IO" class="form-checkbox">
              </div>
              <div class="flex items-center gap-1">
                <label for="destacado">Futuro</label>
                <input id="destacado" type="checkbox" v-model="itemEditable.DESTACADO_IO" class="form-checkbox">
              </div>
              <div class="flex items-center gap-1">
                <label for="activo">Activo</label>
                <input id="activo" type="checkbox" v-model="itemEditable.ACTIVO_IO" class="form-checkbox">
              </div>
            </div>
            <div class="flex justify-center gap-2">
              <button class="btn btn-success" :disabled="cargando" @click="guardarItemOrden()">Guardar</button>
              <button class="btn btn-danger bg-truered" @click="itemEditable = {}">Cancelar</button>
            </div>
          </div>
          <div class="flex items-center flex-wrap">
            <div v-for="(ft, key) in 5" :key="key" 
              @dragover.prevent 
              @drop.prevent="handleDrop($event, key)">
              <div @click="editarImagen(key)" class="cursor-pointer" v-if="!itemEditable['imagen' + (key+1)] || !itemEditable['imagen' + (key+1)].split('|')[0]">
                <img
                  class="d-block w-32 max-h-[400px] object-contain"
                  src="../assets/no-photo.jpg"
                  alt="Imagen del articulo"
                />
              </div>
              <div v-else @click="editarImagen(key)" class="cursor-pointer">
                <img
                  v-if="isImage(itemEditable['imagen' + (key+1)])"
                  :src="itemEditable['imagen' + (key+1)].split('|')[0]"
                  :alt="'Slide '"
                  class="d-block w-32 max-h-[400px] object-contain"
                />
                <video
                  v-else
                  class="d-block w-32 max-h-[400px] object-contain"
                >
                  <source :src="itemEditable['imagen' + (key + 1)].split('|')[0]" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <p>{{ key + 1 }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" id="cambioImagen">
      <div class="modal-dialog">
        <div class="modal-content">
        
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Cambio de imagen</h4>
          </div>
          
          <!-- Modal body -->
          <div class="modal-body">
            <div v-if="imagenTemp">
              <img
                  v-if="isImage(imagenTemp)"
                  :src="imagenTemp.split('|')[0]"
                  :alt="'Slide '"
                  class="d-block w-44 max-h-[400px] object-contain"
                />
                <video
                  v-else
                  controls
                  class="d-block w-44 max-h-[400px] object-contain"
                >
                  <source :src="imagenTemp.split('|')[0]" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
            </div>
            <div v-else>
              <div v-if="!itemEditable['imagen' + (keyImg)] || !itemEditable['imagen' + (keyImg)].split('|')[0]">
                <img
                  class="d-block w-44 max-h-[400px] object-contain"
                  src="../assets/no-photo.jpg"
                  alt="Imagen del articulo"
                />
              </div>
              <div v-else>
                <img
                  v-if="isImage(itemEditable['imagen' + (keyImg)])"
                  :src="itemEditable['imagen' + (keyImg)].split('|')[0]"
                  :alt="'Slide '"
                  class="d-block w-44 max-h-[400px] object-contain"
                />
                <video
                  v-else
                  controls
                  class="d-block w-44 max-h-[400px] object-contain"
                >
                  <source :src="itemEditable['imagen' + (keyImg)].split('|')[0]" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
            <p>{{ keyImg }}</p>
            <input :disabled="cargando" class="mt-2 h-24 w-full border-2 border-dashed border-gray-400 rounded file-input" accept="image/*, video/*" max-size="20MB" type="file" ref="fileInput" @change="onFileChange">
            <p class="text-red-500">Para efectuar el cambio, presione guardar</p>
          </div>
          
          <!-- Modal footer -->
          <div class="modal-footer">
            <button class="btn btn-danger bg-truered" data-bs-dismiss="modal">Cerrar</button>
            <button class="btn btn-success" :disabled="cargando" @click="guardarImg()">Guardar</button>
            <button class="btn btn-warning" :disabled="cargando" title="doble click" @dblclick="borrarImg()">Borrar Imagen</button>
          </div>
          
        </div>
      </div>
    </div>
    <div class="modal" id="itemsQuot">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
        
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Quotation</h4>
          </div>
          
          <!-- Modal body -->
          <div class="modal-body">
            <div>
              <table class="table table-striped table-sm text-xs">
                <thead>
                  <tr>
                    <th scope="col">Foto</th>
                    <th scope="col">Codigo</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Categoria</th>
                    <th scope="col">Subcategoria</th>
                    <th scope="col">Marca</th>
                    <th scope="col">Temporada</th>
                    <th scope="col">Precio</th>
                    <th scope="col">Eliminar</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in cartItems" :key="key">
                    <td class="clickable">
                        <div v-if="!item.imagenPrincipal || !item.imagenPrincipal.split('|')[0]">
                            <img class="d-block w-14 max-h-14 object-contain" src="../assets/no-photo.jpg" alt="Imagen del articulo" />
                        </div>
                        <div v-else>
                            <img 
                                :src="item.imagenPrincipal.split('|')[0]" 
                                :alt="'Imagen del articulo'" 
                                class="d-block w-14 max-h-14 object-contain" 
                            />
                        </div>
                    </td>
                    <td>{{ item.CODIGO_ART }}</td>
                    <td class="text-left">{{ item.DESCRIP_ART }}</td>
                    <td >{{ item.categoria ? item.categoria : ''  }}</td>
                    <td >{{ item.subcategoria ? item.subcategoria : ''  }}</td>
                    <td >{{ item.marca ? item.marca : ''  }}</td>
                    <td >{{ item.temporada }}</td>
                    <td class="text-right">{{ item.PRECIO_LPI.toFixed(2) }}</td>
                    <td><button @click="eliminarQuotation(key)" class="btn btn-danger btn-sm">Eliminar</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pedidosService from '@/services/pedidos.service';
import * as XLSX from 'xlsx'

export default {
  data() {
    return {
      arts: [],
      itemEditable: {},
      items: [],
      categorias: [],
      categoriasOrdenadas: [],
      buscador: '',
      buscadorPrecio: null,
      buscadorEstado: '1',
      buscadorMarca: null,
      buscadorCat: null,
      buscadorSubCat: null,
      cargando: false,
      filtroBusqueda: "",
      tipoFiltro: "",
      ultimoIndex: 1,
      cambioFoto: false,
      keyImg: '',
      file: null,
      imagenTemp: '',
      cantPaginas: 1,
      selectedImage: '',
      cartItems: [],        // aquí guardaremos los artículos seleccionados
      mostrarCarrito: false // control para mostrar/ocultar sección o modal de carrito
    };
  },
  computed: {
    hayFiltros() {
      return this.buscador || this.buscadorMarca || this.buscadorCat || this.buscadorSubCat || (this.buscadorEstado != '1') || this.buscadorPrecio
    }
  },
  methods: {
    eliminarQuotation(key) {
      this.cartItems.splice(key, 1)
    },
    addQuotation(itm) {
      if (this.isIncluded(itm)) return
      this.cartItems.push(itm)
      console.log(this.cartItems)
    },
    isIncluded(itm) {
      return (this.cartItems.some(i => i.ID_IO == itm.ID_IO))
    },
    exportToExcel() {
      // Versión actual, solo exporta la página actual
      const data = this.buscadorMarca != 0 ? this.items : this.arts;
      const exportData = data.map(item => ({
        Codigo: item.CODIGO_ART,
        Nombre: item.DESCRIP_ART,
        Categoria: this.itemEditable.IDART_IO ? '' : item.categoria || '',
        Subcategoria: this.itemEditable.IDART_IO ? '' : item.subcategoria || '',
        Marca: this.itemEditable.IDART_IO ? '' : item.marca || '',
        Temporada: this.itemEditable.IDART_IO ? '' : item.temporada || '',
        Precio: this.itemEditable.IDART_IO ? '' : (item.PRECIO_LPI ? item.PRECIO_LPI.toFixed(2) : ''),
        Oferta: this.itemEditable.IDART_IO ? '' : (item.OFERTA_IO == 1 ? 'Sí' : 'No'),
        Futuro: this.itemEditable.IDART_IO ? '' : (item.DESTACADO_IO == 1 ? 'Sí' : 'No'),
        Activo: this.itemEditable.IDART_IO ? '' : (item.ACTIVO_IO == 1 ? 'Sí' : 'No'),
      }));
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Artículos');
      XLSX.writeFile(workbook, 'articulos.xlsx');
    },

    async exportAllToExcel() {
      // Nueva función: recorre todas las páginas y exporta todos los resultados
      this.cargando = true;
      let allData = [];
      let totalPages = this.cantPaginas;
      let page = 1;
      let fetchFunction;
      let marca = this.buscadorMarca;
      let cat = this.buscadorCat;
      let subcat = this.buscadorSubCat;
      let estado = this.buscadorEstado;
      let precio = this.buscadorPrecio;
      let buscador = this.buscador;

      // Decide qué función usar según los filtros
      if (marca != 0) {
        fetchFunction = (p) => pedidosService.getProductosFiltro(p, buscador, marca, cat, subcat, estado, precio);
      } else {
        fetchFunction = () => pedidosService.getProductosNoAsignados();
        totalPages = 1; // No asignados no tiene paginación
      }

      for (page = 1; page <= totalPages; page++) {
        try {
          let res = await fetchFunction(page);
          let data = Array.isArray(res.data) ? res.data : [];
          // Mapeo de datos al formato deseado
          let exportData = data.map(item => ({
            Codigo: item.CODIGO_ART,
            Nombre: item.DESCRIP_ART,
            Categoria: this.itemEditable.IDART_IO ? '' : item.categoria || '',
            Subcategoria: this.itemEditable.IDART_IO ? '' : item.subcategoria || '',
            Marca: this.itemEditable.IDART_IO ? '' : item.marca || '',
            Temporada: this.itemEditable.IDART_IO ? '' : item.temporada || '',
            Precio: this.itemEditable.IDART_IO ? '' : (item.PRECIO_LPI ? item.PRECIO_LPI.toFixed(2) : ''),
            Oferta: this.itemEditable.IDART_IO ? '' : (item.OFERTA_IO == 1 ? 'Sí' : 'No'),
            Futuro: this.itemEditable.IDART_IO ? '' : (item.DESTACADO_IO == 1 ? 'Sí' : 'No'),
            Activo: this.itemEditable.IDART_IO ? '' : (item.ACTIVO_IO == 1 ? 'Sí' : 'No'),
          }));
          allData = allData.concat(exportData);
        } catch (err) {
          console.log('Error al obtener datos de la página', page, err);
        }
      }

      // Crear worksheet y workbook
      const worksheet = XLSX.utils.json_to_sheet(allData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Artículos');
      XLSX.writeFile(workbook, 'articulos-todas.xlsx');
      this.cargando = false;
    },
    exportQuotation() {
      const idList = this.cartItems.map(item => item.ID_ART);
      this.cargando = true;
      pedidosService.generarExcelQuotation(idList)
        .then(res => {
          const blob = new Blob([res.data], { type: 'application/xlsx' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          const today = new Date();
          const day = String(today.getDate()).padStart(2, '0');
          const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
          const year = today.getFullYear();
          link.setAttribute('download', 'catalogo-'+`${day}-${month}-${year}`+'.xlsx'); // Set the filename for the downloaded file
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((er) => {
          console.log(er)
        })
        .finally(() => {
          this.cargando = false
        })
    },
    exportQuotationPdf() {
      const idList = this.cartItems.map(item => item.ID_ART);
      this.cargando = true;
      pedidosService.generarPdfQuotation(idList)
        .then(res => {
          const blob = new Blob([res.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          const today = new Date();
          const day = String(today.getDate()).padStart(2, '0');
          const month = String(today.getMonth() + 1).padStart(2, '0');
          const year = today.getFullYear();
          link.setAttribute('download', 'quotation-'+`${day}-${month}-${year}`+'.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((er) => {
          console.log(er)
        })
        .finally(() => {
          this.cargando = false
        })
    },
    // exportQuotation() {
    //   // Decide qué datos mostrar (items o arts)
    //   const data = this.cartItems;
    //   // Mapeo de datos al formato deseado
    //   const exportData = data.map(item => ({
    //     Codigo: item.CODIGO_ART,
    //     Nombre: item.DESCRIP_ART,
    //     Categoria: this.itemEditable.IDART_IO ? '' : item.categoria || '',
    //     Subcategoria: this.itemEditable.IDART_IO ? '' : item.subcategoria || '',
    //     Marca: this.itemEditable.IDART_IO ? '' : item.marca || '',
    //     Temporada: this.itemEditable.IDART_IO ? '' : item.temporada || '',
    //     Precio: this.itemEditable.IDART_IO ? '' : (item.PRECIO_LPI ? item.PRECIO_LPI.toFixed(2) : ''),
    //     // Oferta: this.itemEditable.IDART_IO ? '' : (item.OFERTA_IO == 1 ? 'Sí' : 'No'),
    //     // Futuro: this.itemEditable.IDART_IO ? '' : (item.DESTACADO_IO == 1 ? 'Sí' : 'No'),
    //     // Activo: this.itemEditable.IDART_IO ? '' : (item.ACTIVO_IO == 1 ? 'Sí' : 'No'),
    //   }));

    //   // Crear worksheet y workbook
    //   const worksheet = XLSX.utils.json_to_sheet(exportData);
    //   const workbook = XLSX.utils.book_new();
    //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Artículos');

    //   // Exportar a archivo
    //   XLSX.writeFile(workbook, 'articulos.xlsx');
    // },
    openImageDialog(imageUrl) {
        this.selectedImage = imageUrl; // Set the selected image URL
        window.$('#imageDialog').modal('show');
        // Show the dialog
    },
    openQuotModal() {
      window.$('#itemsQuot').modal('show');
    },
    closeImageDialog() {
      window.$('#imageDialog').modal('hide'); // Hide the dialog
      this.selectedImage = ''; // Clear the selected image
    },
    handleDrop(event, key) {
        const fileInput = event.dataTransfer.files[0];
        if (fileInput) {
            this.file = fileInput;

            // Check if the dropped file is an image or video
            const isImage = fileInput.type.startsWith('image/');
            const isVideo = fileInput.type.startsWith('video/');

            if (!isImage && !isVideo) {
                alert('Por favor, suelta un archivo de imagen o video.');
                return;
            }

            const reader = new FileReader();
            reader.onload = () => {
                const blobUrl = URL.createObjectURL(fileInput);
                const formattedUrl = `${blobUrl}|${isImage ? 'image' : 'video'}`;
                this.imagenTemp = formattedUrl; // Set the temporary image/video URL
                this.keyImg = key + 1; // Set the key for the modal
                this.cambioFoto = true; // Indicate that a file has been changed
                window.$('#cambioImagen').modal('show'); // Show the modal
            };

            // Read the file as a data URL
            reader.readAsDataURL(fileInput);
        }
    },
    borrarFiltros() {
      this.buscador = ''
      this.buscadorMarca = null
      this.buscadorCat = null
      this.buscadorSubCat = null
      this.buscadorEstado = '1'
      this.buscadorPrecio = null
      this.cargarProductos(1)
    },
    buscadorFiltros(num) {
      this.cargando = true
      pedidosService.getProductosFiltro(num, this.buscador, this.buscadorMarca, this.buscadorCat, this.buscadorSubCat, this.buscadorEstado, this.buscadorPrecio)
        .then(res => {
          if (res.data.length > 0) {
            // if (num == 1) {
            //   let cant = res.data.pop()
            // }
            this.cantPaginas = Math.ceil(res.data[0].cantPaginas / 25)
            this.items = res.data
            this.ultimoIndex = num
            this.agregarCats();
          } else {
            this.ultimoIndex > 1 ? this.ultimoIndex-- : ''
          }
          this.cargando = false
        })
        .catch((err) => {
          console.log(err)
          this.cargando = false
        })
    },
    async guardarItemOrden() {
      var item = {
        id: this.itemEditable.ID_IO,
        idart: this.itemEditable.IDART_IO,
        orden: this.itemEditable.ORDEN_IO,
        idmarca: this.itemEditable.IDMARCA_IO,
        idcategoria: this.itemEditable.IDCATEGORIA_IO,
        idsubcategoria: this.itemEditable.IDSUBCATEGORIA_IO,
        idtemporada: this.itemEditable.IDTEMPORADA_IO,
        indicacion: this.itemEditable.INDICACION_IO,
        descuento: this.itemEditable.DESCUENTO_IO,
        oferta: this.itemEditable.OFERTA_IO,
        destacado: this.itemEditable.DESTACADO_IO,
        activo: this.itemEditable.ACTIVO_IO
      }
      this.cargando = true
      if (item.id) {
        await pedidosService.putItemOrden(this.itemEditable.ID_IO, item)
          .then(() => {
            this.cargando = false
            this.$root.alertSuccess = true
            this.$root.isAlertVisible = true
          })
          .catch(() => {
            this.cargando = false
            console.log('no se cambio el item')
            this.$root.alertSuccess = false
            this.$root.isAlertVisible = true
          })
      } else {
        await pedidosService.postItemOrden(item)
          .then((res) => {
            this.itemEditable.ID_IO = res.data
            this.cargando = false
            this.$root.alertSuccess = true
            this.$root.isAlertVisible = true
            this.buscarNoAsignados()
          })
          .catch(() => {
            this.cargando = false
            console.log('no se guardo el item')
            this.$root.alertSuccess = false
            this.$root.isAlertVisible = true
          })
      }
    },
    cambioCats(num) {
      if (num && num == 1) {
        this.itemEditable.IDCATEGORIA_IO = null
      }
      this.itemEditable.IDSUBCATEGORIA_IO = null
    },
    buscarNoAsignados() {
      pedidosService.getProductosNoAsignados()
      .then(async res => {
        this.arts = res.data
      })
      .catch((err) => {
        console.log(err)
      })
    },
    cambioBCats(num) {
      if (num == 0) {
        this.buscarNoAsignados()
        return
      }
      if (num && num == 1) {
        this.buscadorCat = null
      }
      this.buscadorSubCat = null
    },
    formatCategorias(cats) {
      var marcas = [];
      cats.forEach((x) => {
        if (!marcas.includes(x.Marca)) {
          marcas.push(x.Marca);
        }
      });
      marcas = marcas.map((x) => {
        return { marca: x, categorias: [] };
      });
      marcas.forEach((x) => {
        x.categorias = [];
        var catsMarca = cats.filter((a) => a.Marca == x.marca);
        catsMarca.forEach((c) => {
          if (!x.categorias.includes(c.Categoria)) {
            x.categorias.push(c.Categoria);
          }
        });
        x.idmarca = catsMarca[0].IDMARCA_IO;

        x.categorias = x.categorias.map((c) => {
          return { categoria: c, subCategorias: [] };
        });

        x.categorias.forEach((c) => {
          var id = cats.filter(
            (a) => a.Marca == x.marca && a.Categoria == c.categoria
          );
          c.idcat = id[0].IDCATEGORIA_IO;
          var temp = cats.filter(
            (a) =>
              a.Marca == x.marca && a.Categoria == c.categoria && a.Subcategoria
          );
          if (temp && temp.length > 0 && temp[0]) {
            c.subCategorias = temp.map((s) => {
              return {
                subcategoria: s.Subcategoria,
                idsubcat: s.IDSUBCATEGORIA_IO,
              };
            });
          } else {
            x.subCategorias = [];
          }
        });
      });

      this.categoriasOrdenadas = marcas;
    },
    guardarImg() {
      if (this.cambioFoto) {
        if (this.isImage(this.imagenTemp)) {
          const formData = new FormData()
          formData.append('file', this.file)
          this.cargando = true
          pedidosService.postImagenProducto(this.itemEditable.ID_IO, this.keyImg, formData) 
            .then(() => {
              this.cargando = false
              this.itemEditable['imagen' + (this.keyImg)] = this.imagenTemp
              this.keyImg = ''
              this.file = null
              this.cambioFoto = false
              this.imagenTemp = ''
              window.$('#cambioImagen').modal('hide')
              this.$root.alertSuccess = true
              this.$root.isAlertVisible = true
            })
            .catch(() => {
              this.cargando = false
              console.log('no se cambio la imagen')
              window.$('#cambioImagen').modal('hide')
              this.$root.alertSuccess = false
              this.$root.isAlertVisible = true
            })
          } else {
            const formData = new FormData()
            formData.append('file', this.file)
            pedidosService.postVideoProducto(this.itemEditable.ID_IO, this.keyImg, formData) 
              .then(() => {
                this.itemEditable['imagen' + (this.keyImg)] = this.imagenTemp
                this.keyImg = ''
                this.file = null
                this.cambioFoto = false
                this.imagenTemp = ''
                window.$('#cambioImagen').modal('hide')
                this.$root.alertSuccess = true
                this.$root.isAlertVisible = true
              })
              .catch(() => {
                console.log('no se cambio la imagen')
                window.$('#cambioImagen').modal('hide')
                this.$root.alertSuccess = false
                this.$root.isAlertVisible = true
              })
          }
      } else {
        window.$('#cambioImagen').modal('hide')
      }
    },
    borrarImg() {
      if (this.itemEditable['imagen' + (this.keyImg)].split('|')[0]) {
        this.cargando = true
        pedidosService.deleteImagenProducto(this.itemEditable.ID_IO, this.keyImg) 
          .then(() => {
            this.cargando = false
            this.itemEditable['imagen' + this.keyImg] = ''
            this.keyImg = ''
            window.$('#cambioImagen').modal('hide')
            this.$root.alertSuccess = true
            this.$root.isAlertVisible = true
          })
          .catch(() => {
            this.cargando = false
            console.log('no se borro la imagen')
            window.$('#cambioImagen').modal('hide')
            this.$root.alertSuccess = false
            this.$root.isAlertVisible = true
          })
      } else {
        window.$('#cambioImagen').modal('hide')
      }
    },
    onFileChange(e) {
      const fileInput = e.target.files[0];
      this.file = fileInput

      // Check if the selected file is smaller than the maximum size (5 MB)
      if (fileInput.size > 20 * 1024 * 1024) {
        alert('La imagen es muy grande, el archivo debe ser menor a 20 MB.');
        this.file = null
        return;
      }

      // Check if it's an image or video based on MIME type
      const isImage = fileInput.type.startsWith('image/');
      const isVideo = fileInput.type.startsWith('video/');

      if (!isImage && !isVideo) {
        alert('Por favor, selecciona un archivo de imagen o video.');
        this.file = null
        return;
      }

      if (isImage) {
        const reader = new FileReader();
        reader.onload = () => {
          // Create a Blob URL based on the MIME type
          const blobUrl = URL.createObjectURL(fileInput);
          const formattedUrl = `${blobUrl}|image`;

          // Now you can use 'formattedUrl' as needed, for example, assign it to a Vue data property
          this.imagenTemp = formattedUrl;
        };

        // Read the file as a data URL
        reader.readAsDataURL(fileInput);
      } else if (isVideo) {
        const videoUrl = URL.createObjectURL(fileInput);
        this.imagenTemp = videoUrl;
      }

      this.cambioFoto = true
    },
    editarImagen(key) {
      this.keyImg = key+1
      window.$('#cambioImagen').modal('show')
    },
    nextPage() {
      this.ultimoIndex++
      if (this.hayFiltros) {
        this.buscadorFiltros(this.ultimoIndex)
        return
      }
      var index = this.ultimoIndex
      if (this.tipoFiltro == "") {
        this.cargarProductos(index);
      } else if (this.tipoFiltro == "+++rango") {
        this.buscarRango(index);
      } else if (this.tipoFiltro.includes("+++categoria")) {
        const stringWithoutPrefix = this.tipoFiltro.split("/").pop();
        const a = stringWithoutPrefix.split(",");
        this.buscarCategoria(index, a[0], a[1], a[2]);
      } else if (this.tipoFiltro == "+++buscador") {
        this.cambioBuscador(index);
      } else if (this.tipoFiltro.includes("+++ordenPrecio")) {
        this.cambioOrdenPrecio(index);
      }
    },
    prevPage() {
      this.ultimoIndex > 1 ? this.ultimoIndex-- : ''
      if (this.hayFiltros) {
        this.buscadorFiltros(this.ultimoIndex)
        return
      }
      var index = this.ultimoIndex 
      if (this.tipoFiltro == "") {
        this.cargarProductos(index);
      } else if (this.tipoFiltro == "+++rango") {
        this.buscarRango(index);
      } else if (this.tipoFiltro.includes("+++categoria")) {
        const stringWithoutPrefix = this.tipoFiltro.split("/").pop();
        const a = stringWithoutPrefix.split(",");
        this.buscarCategoria(index, a[0], a[1], a[2]);
      } else if (this.tipoFiltro == "+++buscador") {
        this.cambioBuscador(index);
      } else if (this.tipoFiltro.includes("+++ordenPrecio")) {
        this.cambioOrdenPrecio(index);
      }
    },
    isImage(url) {
      return url && url.endsWith("image");
    },
    editarItem(index) {
      window.scrollTo(0,0);
      this.itemEditable = this.items[index]
      this.itemEditable.ACTIVO_IO = this.itemEditable.ACTIVO_IO == 1 ? true : false
      this.itemEditable.DESTACADO_IO = this.itemEditable.DESTACADO_IO == 1 ? true : false
      this.itemEditable.OFERTA_IO = this.itemEditable.OFERTA_IO == 1 ? true : false
      this.buscarImagenes()
    },
    editarItemInstancia(index) {
      this.itemEditable = this.items[index]
      this.itemEditable.ACTIVO_IO = false
      this.itemEditable.DESTACADO_IO = false
      this.itemEditable.OFERTA_IO = false
    },
    editarArts(index) {
      window.scrollTo(0,0);
      this.arts[index].ID_IO = null
      this.arts[index].IDART_IO = this.arts[index].ID_ART
      this.itemEditable = this.arts[index]
      this.itemEditable.ACTIVO_IO = this.itemEditable.ACTIVO_IO == 1 ? true : false
      this.itemEditable.DESTACADO_IO = this.itemEditable.DESTACADO_IO == 1 ? true : false
      this.itemEditable.OFERTA_IO = this.itemEditable.OFERTA_IO == 1 ? true : false
      this.guardarItemOrden()
    },
    buscarImagenes() {
      for (var i = 1; i < 6; i++) {
        if (this.itemEditable['FOTO' + i + '_IO']) {
          this.imagenes(i)
        }
      }
    },
    imagenes(i, idart) {
      pedidosService
      .getImagenProducto((idart ? idart : this.itemEditable.IDART_IO), i)
      .then((res) => {
        const contentType = res.headers["content-type"];

        if (
          contentType && (contentType.startsWith("image/") || contentType.startsWith("video/"))) {
          const mediaBlob = new Blob([res.data], { type: contentType });
          const mediaObjectURL = URL.createObjectURL(mediaBlob);
          const blobUrlWithExtension = `${mediaObjectURL}|${i}|${
            contentType.startsWith("image/") ? "image" : "video"
          }`;
          if (idart) {
            this.items.find(itm => itm.IDART_IO == idart).imagenPrincipal = blobUrlWithExtension
          } else {
            this.itemEditable['imagen' + i] = blobUrlWithExtension
          }
        } else {
          if (res.data.byteLength === 0 && i != null) {
            if (idart) {
              this.items.find(itm => itm.IDART_IO == idart).imagenPrincipal = ('|' + 1)
            } else {
              this.itemEditable['imagen' + i] = ('|' + i);
            }
          } else {
            console.error(
              "The response does not contain valid media data. Content-Type:",
              contentType
            );
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
    },
    getAllCategorias() {
      pedidosService
      .getAllCategorias()
      .then((res) => {
        this.categorias = res.data;
        this.formatCategorias(this.categorias)
        this.buscadorFiltros(1)
      })
      .catch((res) => {
        console.log(res);
      });
    },
    // getAllItems() {
    //   pedidosService.getAllProductos()
    //     .then((res) => {
    //       this.items = res.data
    //       this.items.forEach(x => {
    //         x.marca = x.IDMARCA_IO ? this.categorias.find(m => m.IDMARCA_IO == x.IDMARCA_IO).Marca : ''
    //         var cat = this.categorias.find(m => m.IDCATEGORIA_IO == x.IDCATEGORIA_IO) ? this.categorias.find(m => m.IDCATEGORIA_IO == x.IDCATEGORIA_IO).Categoria : ''
    //         x.categoria = cat
    //         var subcat = this.categorias.find(m => m.IDSUBCATEGORIA_IO == x.IDSUBCATEGORIA_IO) ? this.categorias.find(m => m.IDSUBCATEGORIA_IO == x.IDSUBCATEGORIA_IO).Subcategoria : ''
    //         x.subcategoria = subcat
    //       })
    //     })
    //     .catch(err => {
    //       console.log(err)
    //     })
    // },
    resetFiltros() {
      this.orden = "pd";
      this.buscador = "";
      this.filtroBusqueda = "";
    },
    agregarCats() {
      this.items.forEach(x => {
        x.marca = x.IDMARCA_IO ? this.categorias.find(m => m.IDMARCA_IO == x.IDMARCA_IO).Marca : ''
        var cat = this.categorias.find(m => m.IDCATEGORIA_IO == x.IDCATEGORIA_IO) ? this.categorias.find(m => m.IDCATEGORIA_IO == x.IDCATEGORIA_IO).Categoria : ''
        x.categoria = cat
        var subcat = this.categorias.find(m => m.IDSUBCATEGORIA_IO == x.IDSUBCATEGORIA_IO) ? this.categorias.find(m => m.IDSUBCATEGORIA_IO == x.IDSUBCATEGORIA_IO).Subcategoria : ''
        x.subcategoria = subcat
        this.cargarPrimerImagen(x)
      })
    },
    cambioOrdenAux() {
      if (this.orden != 'pMm') {
        this.orden = 'pMm'
      } else {
        this.orden = 'pmM'
      }
      this.cambioOrdenPrecio(1)
    },
    cambioOrdenPrecio(index) {
      if (this.orden == "pMm" || this.orden == "pmM") {
        this.cargando = true;
        var orden = this.orden;
        this.resetFiltros();
        this.orden = orden;
        orden = this.orden == "pMm" ? 1 : 0;
        pedidosService
          .getProductosConIndexOrdenPrecio(index, orden)
          .then((res) => {
            this.cargando = false;
            if (res.data.length == 0) {
              this.ultimoIndex > 1 ? this.ultimoIndex-- : ''
              return
            }
            if (this.tipoFiltro != "+++ordenPrecio/" + orden) {
              this.items = [];
              this.ultimoIndex = 1
            }
            this.items = res.data
            this.tipoFiltro = "+++ordenPrecio/" + orden;
            this.items.forEach(i => {
              this.cargarPrimerImagen(i)
            })
            this.agregarCats();              
          })
          .catch((err) => {
            console.log(err);
            this.cargando = false;
          });
      }
    },
    buscarCategoria(index, filtro, idm, idc, ids) {
      this.cargando = true;
      this.resetFiltros();
      pedidosService
        .getProductosConIndexCategoria(
          index,
          idm,
          idc ? idc : -1,
          ids ? ids : -1
        )
        .then((res) => {
          this.cargando = false;
          if (res.data.length == 0) {
            this.ultimoIndex > 1 ? this.ultimoIndex-- : ''
            return
          }
          if (
            this.tipoFiltro !=
            "+++categoria/" + idm + "," + idc + "," + ids
          ) {
            this.items = [];
            this.ultimoIndex = 1

          }
          this.filtroBusqueda = filtro;
          this.items = res.data
          this.tipoFiltro = "+++categoria/" + idm + "," + idc + "," + ids;
          this.agregarCats();
          
          
        })
        .catch((err) => {
          console.log(err);
          this.cargando = false;
        });
    },
    cambioBuscador(index) {
      if (this.buscador) {
        this.cargando = true;
        var buscador = this.buscador;
        this.resetFiltros();
        this.buscador = buscador;
        pedidosService
          .getProductosConIndexBusqueda(index, this.buscador)
          .then((res) => {
            this.cargando = false;
            if (res.data.length == 0) {
              this.ultimoIndex > 1 ? this.ultimoIndex-- : ''
              return
            }
            if (this.tipoFiltro != "+++buscador") {
              this.items = [];
              this.ultimoIndex = 1

            }
            this.filtroBusqueda = this.buscador;
            this.items = res.data
            this.items.forEach(i => {
              this.cargarPrimerImagen(i)
            })
            this.tipoFiltro = "+++buscador";
            this.agregarCats();              
          })
          .catch((err) => {
            console.log(err);
            this.cargando = false;
          });
      } else {
        this.cargarProductos(1);
      }
    },
    cargarProductos(index) {
      this.cargando = true;
      this.resetFiltros();
      pedidosService
        .getProductosConIndex(index)
        .then((res) => {
          this.inde
          this.cargando = false;
          if (res.data.length == 0) {
            this.ultimoIndex > 1 ? this.ultimoIndex-- : ''
            return
          }
          if (this.tipoFiltro != "") {
            this.items = [];
            this.ultimoIndex = 1

          }
          this.filtroBusqueda = "";
          this.items = res.data
          this.items.forEach(i => {
            this.cargarPrimerImagen(i)
          })
          this.tipoFiltro = "";
          this.agregarCats();
          this.ultimoIndex = index
          this.cantPaginas = Math.ceil(res.data[0].cantPaginas / 25)
          
        })
        .catch((err) => {
          console.log(err);
          this.cargando = false;
        });
    },
    cargarPrimerImagen(i) {
      this.imagenes(1, i.IDART_IO)
    }
  },
  mounted() {
    this.getAllCategorias()
  },
};
</script>

<style>
/* .modal {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
} */
.modal-dialog {
    background: white;
    border-radius: 8px;
    padding: 20px;
}
.clickable:hover {
  cursor: pointer;
}
</style>

